import React, { FC } from 'react'
import t from '../../../../../translations/main'
import { Trans } from 'react-i18next'
import config from './config'
import utils from '../../../../../components/Organisms/Form/utils'
import useForm, { OnSubmitParams } from '../../../../../components/Core/Hooks/useForm/useForm'
import { useDropdownOptions } from 'src/components/Core/Context/OnboardingContext'

import Button from '../../../../../components/Atoms/Button/Button'

import {
  FormStyle,
  FormHeader,
  FormTitle,
  FormDescription,
  FormFooter,
  FormFooterActionsLeft,
  FormFooterActionsRight,
} from '../../../../../components/Organisms/Form/Form.styles'

import { FormProps } from '../../../../Pages/Onboarding/types'

const DeclarationsForm: FC<FormProps> = props => {
  const { dropdownOptions } = useDropdownOptions()

  const submitForm = ({data, options, configData, setConfigData}: OnSubmitParams) => {
    const { submit } = props
    if (submit) submit({ data, options, configData, setConfigData })
  }

  const {
    formData,
    // emptyValidation,
    handleInputChange,
    handleSubmit,
    configData,
  } = useForm(
    props.fetchedData,
    config({ countryTelephoneCodes: dropdownOptions.countryTelephoneCodes }),
    submitForm
  )
  const isDisableByCheckbox = () => ['certifyAuthorisedSign','allStatmentsMadeCorrect','takeSucdenAdvise','dataProtectionPolicyConfirmation','informationAcknowledgement', 'agreeToBoundForProvisions']
  // @ts-ignore
    .some(item => formData[`${item}`].value === false)

  // this will change in the future, now the docs are NOT mandatory, when they are then uncomment below so the docs from direcots and UBOs are checked
  // const checkDirectorsAndUbosFiles = () => {
  //   if(formData?.directorUboProofs?.value) return true
  //   const missingFile = Array.isArray(formData.directorUboProofs.value) && formData.directorUboProofs.value.some(entry => {
  //     const isPpMissing = entry.ppDocument.documentName === ''
  //     const isUbMissing = entry.ubDocument.documentName === ''
  //     return (isPpMissing || isUbMissing)
  //   })
  //   return missingFile
  // }

  return (
    <FormStyle onSubmit={handleSubmit}>
      <FormHeader>
        <FormTitle>
          {t('onboarding.forms.CorporateAccount.DeclarationsForm.title')}
        </FormTitle>
        <FormDescription>
          {/* @ts-ignore-next-line */}
          <Trans i18nKey='onboarding.forms.CorporateAccount.DeclarationsForm.description' />
        </FormDescription>
      </FormHeader>
      {utils.sectionBuilder(configData, formData, handleInputChange)}
      <FormFooter noOfButtons={2}>
        <FormFooterActionsLeft>
          <Button
            label={t('onboarding.main.backButton')}
            version={2}
            disabled={props.disablePrev}
            onClick={props.prevStep}
          />
        </FormFooterActionsLeft>
        <FormFooterActionsRight>
          <Button
            type='submit'
            label={props.isLastForm ? t('onboarding.main.saveAndSubmit') : t('onboarding.main.continueButton')}
            disabled={
              isDisableByCheckbox()
              // this will change in the future, now the docs are NOT mandatory, when they are then uncomment below so the docs from direcots and UBOs are checked
              // || emptyValidation 
              // || checkDirectorsAndUbosFiles()
            }
          />
        </FormFooterActionsRight>
      </FormFooter>
    </FormStyle>
  )
}

export default DeclarationsForm
